var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout"},[(_vm.user)?_c('div',[_vm._v("Пока :)")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }